import {DI_TOKENS} from '@/di/di.tokens';

import {Container} from 'brandi';

import {AssetsLoader} from '@/services/AssetsLoader/AssetsLoader';
import {BonusesStore} from '@/stores/BonusesStore/BonusesStore';
import {ImageLoaderStore} from '@/stores/ImageLoaderStore/ImageLoaderStore';
import {ItemModalContentStore} from '@/stores/ItemModalContentStore/ItemModalContentStore';
import {ItemsStore} from '@/stores/ItemsStore/ItemsStore';
import {OnboardingStore} from '@/stores/OnboardingStore/OnboardingStore';
import {TimerStore} from '@/stores/TimerStore/TimerStore';
import {UserItemsStore} from '@/stores/UserItemsStore/UserItemsStore';
import {UserEnergyStore} from '@/stores/UserStores/UserEnergyStore';
import {UserStore} from '@/stores/UserStores/UserStore';
import {ViewportStore} from '@/stores/ViewportStore/ViewportStore';
import {TitleAnimation} from '@/ui/components/TitleAnimation/Animation';
import {OnboardingFinishUseCase} from '@/useCases/OnboardingFinishUseCase/OnboardingFinishUseCase';
import {SubscriptionChangeUseCase} from '@/useCases/SubscriptionChangeUseCase/SubscriptionChangeUseCase';
import {BonusesInfoSharedUseCase} from '@/useCases/shared/BonusesInfoSharedUseCase/BonusesInfoSharedUseCase';
import {ItemContentSharedUseCase} from '@/useCases/shared/ItemContentSharedUseCase/ItemContentSharedUseCase';
import {OpenItemSharedUseCase} from '@/useCases/shared/OpenItemSharedUseCase/OpenItemSharedUseCase';
import {TimerUpdateSharedUseCase} from '@/useCases/shared/TimerUpdateSharedUseCase/TimerUpdateSharedUseCase';

export function initDomainDeps(container: Container): void {
  if (process.env.APP_PROJECT_API_MOCK_ENABLED === 'true') {
    container
      .bind(DI_TOKENS.projectApi)
      .toInstance(require('@/services/ProjectApi/ProjectApiMock').ProjectApiMock)
      .inSingletonScope();
  } else {
    container
      .bind(DI_TOKENS.projectApi)
      .toInstance(require('@/services/ProjectApi/ProjectApi').ProjectApi)
      .inSingletonScope();
  }

  container.bind(DI_TOKENS.userStore).toInstance(UserStore).inSingletonScope();
  container.bind(DI_TOKENS.userEnergyStore).toInstance(UserEnergyStore).inSingletonScope();
  container.bind(DI_TOKENS.timerStore).toInstance(TimerStore).inSingletonScope();
  container.bind(DI_TOKENS.bonusesStore).toInstance(BonusesStore).inSingletonScope();
  container.bind(DI_TOKENS.itemsStore).toInstance(ItemsStore).inSingletonScope();
  container.bind(DI_TOKENS.userItemsStore).toInstance(UserItemsStore).inSingletonScope();
  container.bind(DI_TOKENS.itemModalContentStore).toInstance(ItemModalContentStore).inSingletonScope();
  container.bind(DI_TOKENS.viewportStore).toInstance(ViewportStore).inSingletonScope();
  container.bind(DI_TOKENS.onboardingStore).toInstance(OnboardingStore).inSingletonScope();
  container.bind(DI_TOKENS.titleAnimation).toInstance(TitleAnimation).inSingletonScope();
  container.bind(DI_TOKENS.assetsLoader).toInstance(AssetsLoader).inSingletonScope();
  container.bind(DI_TOKENS.onboardingFinishUseCase).toInstance(OnboardingFinishUseCase).inSingletonScope();
  container.bind(DI_TOKENS.subscriptionChangeUseCase).toInstance(SubscriptionChangeUseCase).inSingletonScope();
  container.bind(DI_TOKENS.timerUpdateSharedUseCase).toInstance(TimerUpdateSharedUseCase).inSingletonScope();
  container.bind(DI_TOKENS.bonusesInfoSharedUseCase).toInstance(BonusesInfoSharedUseCase).inSingletonScope();
  container.bind(DI_TOKENS.itemContentSharedUseCase).toInstance(ItemContentSharedUseCase).inSingletonScope();
  container.bind(DI_TOKENS.openItemSharedUseCase).toInstance(OpenItemSharedUseCase).inSingletonScope();
  container.bind(DI_TOKENS.imageLoaderStore).toInstance(ImageLoaderStore).inSingletonScope();
}
